
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GeoItem',
  props: ['text', 'img'],
})
